import React, { useEffect } from "react";

function Snackbar({ show, message, type = "success", onClose, autoHideDuration = 3000 }) {
  useEffect(() => {
    if (!show) return;
    if (!autoHideDuration) return;
    const timer = setTimeout(() => {
      onClose && onClose();
    }, autoHideDuration);
    return () => clearTimeout(timer);
  }, [show, autoHideDuration, onClose]);

  if (!show) return null;

  return (
    <div
      className={`toast align-items-center text-white bg-${type} position-fixed bottom-0 end-0 m-3 show`}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      style={{ zIndex: 1080 }}
    >
      <div className="d-flex">
        <div className="toast-body">{message}</div>
        <button
          type="button"
          className="btn-close btn-close-white me-2 m-auto"
          onClick={onClose}
        ></button>
      </div>
    </div>
  );
}

export default Snackbar;

